import { render, staticRenderFns } from "./abilityBroker.vue?vue&type=template&id=24cd473b&scoped=true"
import script from "./abilityBroker.vue?vue&type=script&lang=js"
export * from "./abilityBroker.vue?vue&type=script&lang=js"
import style0 from "./abilityBroker.vue?vue&type=style&index=0&id=24cd473b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cd473b",
  null
  
)

export default component.exports